import React from "react";
import { Label } from "@fluentui/react-components";
import { isGulping, isGulpOrBranching } from "owa-config";
import { devSourceLabel } from "../OwaHeader.scss";

const OwaHeaderDevSourceLabel: React.FC = React.memo(() => {
    return isGulpOrBranching() ? (<Label className={devSourceLabel}>{isGulping() ? "gulping..." : "branching..."}</Label>) : null;
});

export default OwaHeaderDevSourceLabel;
